import { FC } from 'react';
import clsx from 'clsx';

import './TeamMemberAvatar.scss';

interface TeamMemberAvatarProps {
  name: string;
  initials: string;
  photoUrl?: string;
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  className?: string;
}

const TeamMemberAvatar: FC<TeamMemberAvatarProps> = ({
  name,
  initials,
  photoUrl,
  size = 'small',
  className,
}) => {
  return (
    <span className={clsx('team-member-avatar', `team-member-avatar--${size}`, className)} aria-label={name}>
      {photoUrl ? <img src={photoUrl} alt="" /> : initials}
    </span>
  );
};

export default TeamMemberAvatar;
